export default "__VITE_ASSET__CbtoUKHj__"